/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FromToValue {
    getFixupPrototypeFunction() { return FromToValue.fixupPrototype; }

    static newInstance(model: Partial<FromToValue>): FromToValue {
        let obj = Object.assign(new FromToValue(), model);
        FromToValue.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FromToValue>): FromToValue {
        if (!model) return null;
        return FromToValue.newInstance(<FromToValue> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FromToValue) {
        if (!obj) return;

        models.FromToValue.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FromToValue): boolean {
        Object.setPrototypeOf(obj, FromToValue.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.from === undefined) {
            this.from = 0;
        }
        if (this.to === undefined) {
            this.to = 0;
        }
    }

    /**
     * Starting value of the range.Example 'from': 1000
     */
    from: number;

    /**
     * Ending value of the range.Example 'to': 100000
     */
    to: number;

}
